module.exports = __webpack_public_path__ + "static/media/Icon_Globe-Country.744ce656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Globe-Country.svg
// module id = 2316
// module chunks = 0